import { useRef } from 'react'

import CountrySelect from '@/components/molecules/CountrySelect'
import Hubs from '@/components/organisms/Hubs'
import { useHeightObserver } from '@/hooks/useHeightObserver'
import { useMobileLayoutStore } from '@/stores/MobileLayoutStore'
import { cn } from '@/util/cn'

export default function ConfiguratorHeader() {
  const { isMobile, activeMobileTab } = useMobileLayoutStore()
  const ref = useRef<HTMLDivElement>(null)
  useHeightObserver(ref, '--header-height')

  return (
    <div
      ref={ref}
      style={{ top: 'calc(var(--navbarHeight) + var(--secondbarHeight))' }}
      className={cn(
        'sticky z-20 grid grid-cols-4 gap-[2px] border-b-4 border-rsf-white-background bg-rsf-white-background md:grid-cols-[repeat(auto-fit,_minmax(150px,_1fr))]',
        isMobile && activeMobileTab === 'deluxe' && 'grid-cols-4',
      )}
    >
      <CountrySelect />
      <Hubs />
    </div>
  )
}
